import React, { useEffect, useState } from 'react';

import LanguageIcon from '@mui/icons-material/Language';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Typography, Stack, Grid, Box, Button } from '@mui/material';
import html2canvas from 'html2canvas';

import { Investors } from '..';
import { CustomPie, ScreenShotHeader } from '../../common_components';
import { StyledTextBox } from '../../common_components/styled';
import logo from '../../images/logo.png';

import { CenteredMetric } from './Tokenomics';
import { TokenVesting } from './TokenVesting';

export const ScreenShotsSection = (tokenDetails) => {
  const { alloc_details, total_supply } = tokenDetails;

  const [tokenomicsData, setTokenomicsData] = useState([]);

  useEffect(() => {
    const data = alloc_details?.map((item) => ({
      id: item.type,
      label: item.type,
      value: item.alloc_supply,
      allocation_per: item.allocation
    }));
    setTokenomicsData(data);
  }, []);

  const printPDF = () => {
    const node = document.getElementById('screenshot');
    html2canvas(node, { useCORS: true }).then((canvas) => {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.download = 'screenshot.png';
      a.href = canvas.toDataURL();
      a.click();
    });
  };
  return (
    <Box sx={{ m: 2, p: 2 }} elevation={3} id="screenshot">
      <ScreenShotHeader {...tokenDetails} />

      <Grid container spacing={1} sx={{ margin: 1 }}>
        <Grid
          item
          xs={12}
          md={7}
          spacing={1}
          sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Stack display="flex">
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              sx={{ textAlign: 'center', mt: 5, mb: 5 }}>
              {`Token Vesting Schedule`}{' '}
            </Typography>
            <TokenVesting {...tokenDetails} />
          </Stack>
        </Grid>
        <Grid item xs={12} md={5}>
          <Box sx={{ height: '40%' }}>
            <CustomPie
              data={tokenomicsData}
              total_supply={total_supply}
              CustomLayerComponent={CenteredMetric}
              pieProps={{
                height: 320,
                margin: {
                  top: 30,
                  right: 60,
                  bottom: 60,
                  left: 60
                }
              }}
            />
          </Box>
          <Box sx={{ mt: 10 }}>
            {tokenDetails?.investors?.length > 0 && <Investors {...tokenDetails} />}
          </Box>
        </Grid>

        <Grid item md={4} sx={{ paddingTop: '0px !important' }}>
          <Stack direction="row" alignItems="center">
            <img src={logo} height="50px" className="logo" />
          </Stack>
        </Grid>
        <Grid
          item
          md={4}
          sx={{
            paddingLeft: '50px !important',
            display: 'flex',
            justifyContent: 'flex-start',
            paddingTop: '0px !important'
          }}>
          <StyledTextBox>
            <LanguageIcon sx={{ color: '#3d79e9' }} />

            <Typography variant="h5" sx={{ pl: 1 }}>{` Coinowl.io`}</Typography>
          </StyledTextBox>
        </Grid>

        <Grid
          item
          md={4}
          sx={{
            justifyContent: 'flex-end',
            display: 'flex',
            paddingRight: '50px',
            paddingTop: '0px !important'
          }}>
          <Box
            sx={{
              border: 1,
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              bgcolor: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <TelegramIcon sx={{ color: 'white' }} />
          </Box>
          <Box
            sx={{
              ml: 0.5,
              border: 1,
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              bgcolor: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <TwitterIcon sx={{ color: 'white' }} />
          </Box>

          <Typography variant="h5" sx={{ pl: 1 }}>{`@Coinowl_io`}</Typography>
        </Grid>
      </Grid>

      <Stack alignItems="center" display="flex" data-html2canvas-ignore="true">
        <Button
          sx={{ m: 1, maxWidth: 200 }}
          onClick={printPDF}
          textAlign="center"
          variant="outlined"
          color="secondary">
          {'Download'}
        </Button>
      </Stack>
    </Box>
  );
};
